// ──────────────────────────────────────────────────────────────────────
// Iter 63 Item 1 — Assignee avatar stack for task rows.
// Renders the first N (default 2) assignees as overlapping circular
// avatars + an optional "+M" overflow chip when there are more. Each
// avatar gets a tooltip with the assignee's full name (and role, if
// supplied via Item 2's UserChip helpers).
// ──────────────────────────────────────────────────────────────────────
import { roleLabel } from './AssigneeMultiSelect';

function initials(name) {
  if (!name) return '?';
  const parts = String(name).trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function AssigneeAvatars({
  assignees = [],
  members = [],
  max = 2,
  size = 'sm',
  showRole = true,
}) {
  // assignees can be either array of {id,name,role} (assignee_details from
  // backend enrichment) OR array of bare user IDs (assigned_to). Resolve.
  const resolved = (assignees || []).map(a => {
    if (typeof a === 'string') {
      const m = (members || []).find(x => x.id === a);
      return m || { id: a, name: a.slice(0, 8) };
    }
    return a;
  });
  if (resolved.length === 0) return null;
  const visible = resolved.slice(0, max);
  const overflow = resolved.length - visible.length;
  const dim = size === 'xs' ? 'h-4 w-4 text-[8px]' : size === 'md' ? 'h-7 w-7 text-[11px]' : 'h-5 w-5 text-[9px]';
  return (
    <div className="flex items-center -space-x-1.5 shrink-0" data-testid="assignee-avatars">
      {visible.map((a, i) => {
        const tip = (a.name || a.email || '?') +
          (showRole && a.role ? ` (${roleLabel(a.role)})` : '');
        return (
          <div
            key={a.id || i}
            title={tip}
            className={`${dim} rounded-full bg-secondary border border-card flex items-center justify-center font-medium text-foreground/70`}
            data-testid={`assignee-avatar-${a.id || i}`}
          >
            {initials(a.name || a.email)}
          </div>
        );
      })}
      {overflow > 0 && (
        <div
          className={`${dim} rounded-full bg-foreground/10 border border-card flex items-center justify-center font-medium text-muted-foreground/70`}
          title={resolved.slice(max).map(a => (a.name || a.email || '?') + (showRole && a.role ? ` (${roleLabel(a.role)})` : '')).join(', ')}
          data-testid="assignee-avatar-overflow"
        >
          +{overflow}
        </div>
      )}
    </div>
  );
}
